import { baseService } from './base';

export interface InsuranceSetting {
  id: string;
  key: string;
  value: number;
  description?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface InsuranceCalculation {
  rate: number;
  premium: number;
  coverage: number;
}

export interface UpdateInsuranceSettingDto {
  value?: number;
  description?: string;
  isActive?: boolean;
}

class InsuranceSettingsService {
  async getAll(): Promise<InsuranceSetting[]> {
    const response = await baseService.get('/insurance-settings');
    return response.data;
  }

  async updateByKey(key: string, value: number): Promise<InsuranceSetting> {
    const response = await baseService.put(`/insurance-settings/key/${key}`, { value });
    return response.data;
  }

  async calculateInsurance(declaredValue: number): Promise<InsuranceCalculation> {
    const response = await baseService.get('/insurance-settings/calculate', {
      params: { declaredValue },
    });
    return response.data;
  }

  async update(id: string, updateDto: UpdateInsuranceSettingDto): Promise<InsuranceSetting> {
    const response = await baseService.put(`/insurance-settings/${id}`, updateDto);
    return response.data;
  }
}

export const insuranceSettingsService = new InsuranceSettingsService();
